import { useState } from "react";
import { useModalStore } from "../../../stores/modalStore.js";
import { useDirectMessageStore } from "../../../stores/directMessageStore.js";
import { Search, UserPlus } from "lucide-react";

const AVAILABLE_USERS = [
  { id: 'user-2', name: 'Alex Rivera', avatar: '🎮', status: 'online' },
  { id: 'user-3', name: 'Jordan Smith', avatar: '⚔️', status: 'idle' },
  { id: 'user-4', name: 'Casey Lee', avatar: '🚀', status: 'offline' },
  { id: 'user-5', name: 'Morgan Taylor', avatar: '💎', status: 'online' },
];

export default function UserDiscoveryModal() {
  const { isOpen, type, onClose } = useModalStore();
  const { createConversation, setCurrentConversation } = useDirectMessageStore();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState("users"); // 'users' or 'servers'

  if (!isOpen || type !== "discovery") return null;

  const filteredUsers = AVAILABLE_USERS.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleStartDM = (user) => {
    createConversation(user.id, user.name, user.avatar);
    const convId = `dm-${user.id}`;
    setCurrentConversation(convId);
    onClose();
  };

  return (
    <div
      className="modal-overlay fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="modal-content bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-6 w-full max-w-md max-h-96"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">Find Friends & Servers</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl">
            ✕
          </button>
        </div>

        {/* Search */}
        <div className="relative mb-4">
          <Search size={18} className="absolute left-3 top-2.5 text-gray-500" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search users..."
            className="w-full pl-10 pr-3 py-2 bg-[#0f0f0f] border border-[#2a2a2a] rounded text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
          />
        </div>

        {/* Results */}
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {filteredUsers.length > 0 ? (
            filteredUsers.map((user) => (
              <div
                key={user.id}
                className="flex items-center justify-between p-3 bg-[#2a2a2a] rounded hover:bg-[#3a3a3a] transition"
              >
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-lg text-white">
                    {user.avatar}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{user.name}</p>
                    <p className="text-xs text-gray-500">
                      🟢 {user.status === 'online' ? 'Online' : user.status === 'idle' ? 'Idle' : 'Offline'}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => handleStartDM(user)}
                  className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium px-3 py-1 rounded transition"
                >
                  <UserPlus size={14} />
                  Add
                </button>
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-gray-500">
              <p>No users found</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <button
          onClick={onClose}
          className="w-full mt-4 bg-[#2a2a2a] hover:bg-[#3a3a3a] text-white font-medium py-2 rounded transition"
        >
          Close
        </button>
      </div>
    </div>
  );
}
